import request from 'utils/request';
import config from 'config/Config';
import { hex_md5, Encrypts } from 'utils/md5';
import { decryptParams } from 'utils/constants';

export default class {
  /**
   * 获取验证码
   */
  static getVerifyCode(params) {
    return request({
      url: `user/verifyCode/getVerifyCodeV3`,
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 获取会员登录图形验证码
   */
  static getMemberGraphCode(params) {
    return request({
      url: `user/login/getImageCode`,
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 校验图形二维码
   */
  static getImageCode(params) {
    return request({
      url: `user/verifyCode/checkCaptcha`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 获取店铺登录图形验证码
   */
  static getStoreGraphCode(params) {
    return request({
      url: `user/login/getImageCode`,
      host: config.HOST_STORE,
      params
    });
  }

  /**
   * 会员卡登录 (微信绑定会员卡也用这个)
   */
  static loginByMember(params, tip) {
    return request({
      url: 'user/login/memberCardLogin',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params,
      ignoreErr: !tip
    });
  }

  /**
   * 手机号登录 (微信绑定手机号也用这个)
   */
  static loginByPhone(params) {
    return request({
      url: 'user/login/login',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params,
      ignoreErr: true
    });
  }

  /**
   * 店铺登录
   */
  static loginByStore(params) {
    return request({
      url: 'user/login/shopLogin',
      host: config.HOST_STORE,
      method: 'post_json',
      data: params,
      ignoreErr: true
    });
  }

  /**
   * 微信登录
   */
  static loginByWechat() {
    return request({
      url: 'user/login/login',
      host: config.HOST_MALL,
      method: 'post_json'
    });
  }

  /**
   * 获取第三方登录编码
   */
  static getThirdCode(params) {
    return request({
      url: 'user/login/getThirdCode',
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 会员忘记密码 - 验证用户身份
   */
  static confirmUser(params) {
    return request({
      url: 'user/login/confirmUser',
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 会员修改密码（忘记密码时）
   */
  static alterPasswordByIdCard(params) {
    return request({
      url: 'user/login/resetPassword',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 会员修改密码（个人中心修改密码时）
   */
  static alterPasswordByAccount(params) {
    return request({
      url: 'user/info/updatePassword',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }
  /**
   * 通过手机号重置密码
   */
  static alterPasswordByMobile(params) {
    return request({
      url: 'user/login/resetPasswordByPhone',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 店铺忘记密码 - 验证店铺身份
   */
  static verifyStore(params) {
    return request({
      url: 'user/login/resetPasswordFirst',
      host: config.HOST_STORE,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 店铺重置密码（使用证件等资料修改为新密码）
   */
  static alterStorePassword(params) {
    return request({
      url: 'user/login/resetPassword',
      host: config.HOST_STORE,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 店铺重置密码（使用旧密码修改为新密码）
   */
  static alterStorePassword_2(params) {
    return request({
      url: 'user/login/updatePassword',
      host: config.HOST_STORE,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 安全验证
   */
  static verifyPhone(params) {
    return request({
      url: 'user/login/memberCardLogin',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 更改手机号通过证件号验证
   */
  static checkIdentityCard(params) {
    console.log('🎻', params);
    return request({
      url: 'user/verifyCode/checkIdentityCard?identityCard=' + params.identityCard,
      host: config.HOST_MALL,
      data: params
    });
  }

  /**
   * 更换手机号（通过个人中心）
   */
  static alterPhoneByAccount(url, params) {
    return request({
      url,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 更换手机号（通过个人中心）
   */
  static memberToPhoneByAccount(params) {
    return request({
      url: 'user/info/bindPhone',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 微信静默登录
   */
  static h5WechatLogin(params) {
    return request({
      url: 'user/login/h5WechatLogin',
      host: config.HOST_MALL,
      params,
      ignoreErr: true
    });
  }

  /**
   * 绑定微信(LY)
   */
  static bindWechatLY(params) {
    return request({
      url: 'user/binding/userCenter/oauthBind',
      host: config.HOST_MALL,
      method: 'post_json',
      params
    });
  }
  /**
   * 绑定微信
   */
  static bindWechat(params) {
    return request({
      url: 'user/binding/userCenter/bindWechat',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 解绑微信(LY)
   */
  static detachWechatLY(params) {
    return request({
      url: 'user/binding/userCenter/unBindWechatPlatform',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }
  /**
   * 解绑微信
   */
  static detachWechat(params) {
    return request({
      url: 'user/binding/userCenter/unBindWechat',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 根据code获取微信openId、accessToken等信息
   */
  static getTokenByCode(params) {
    return request({
      url: 'user/login/checkWechatCode',
      host: config.HOST_MALL,
      params
    });
  }
  /**
   * 根据openId获取密码
   */
  static getPwdByOpenId(params) {
    return request({
      url: 'user/login/getRememberPassword',
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 根据openId, accessToken获取微信用户信息
   */
  static getWxMsgByToken(params) {
    return request({
      url: 'user/login/getWechatUserInfo',
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 获取appid
   */
  static getWechatLoginUrl(params) {
    return request({
      url: 'user/login/wechatLoginUrl',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 获取微信openid
   */
  static getWechatOpenid(params) {
    return request({
      url: `user/login/checkWechatCode${params && params.md5Sign ? '/scan' : ''}`,
      host: config.HOST_MALL,
      ignoreErr: true,

      params
    });
  }

  static getYongyiPayInfo(params) {
    return request({
      url: `biz/tradecore/order/getWechatAppId${
        params && params.md5Sign ? '/scan' : ''
      }?payWay=102&payPartnerCode=YONGYI`,
      host: config.HOST_MALL,
      params
    });
  }

  static getWechatPayInfo(params) {
    return request({
      url: `biz/tradecore/order/getWechatAppId${
        params && params.md5Sign ? '/scan' : ''
      }?payWay=100&payPartnerCode=WECHAT`,
      host: config.HOST_MALL,
      params
    });
  }

  static getHuiJuPayInfo(params) {
    return request({
      url: `biz/tradecore/order/getWechatAppId${
        params && params.md5Sign ? '/scan' : ''
      }?payWay=101&payPartnerCode=HUIJU_WECHAT`,
      host: config.HOST_MALL,
      params
    });
  }

  static getKuaiQianInfo(params) {
    return request({
      url: `biz/tradecore/order/getWechatAppId${
        params && params.md5Sign ? '/scan' : ''
      }?payWay=101&payPartnerCode=KUAIQIAN_WECHAT`,
      host: config.HOST_MALL,
      params
    });
  }

  /**
   *获取合利宝支付appid信息
   * @static
   * @return {*}
   */
  static getHeLiBaoPayInfo(params) {
    return request({
      url: `biz/tradecore/order/getWechatAppId${
        params && params.md5Sign ? '/scan' : ''
      }?payWay=101&payPartnerCode=HELIBAO_WECHAT`,
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 获取汇付天下支付appid信息
   * @static
   * @return {*}
   */
  static getHuiFuPayInfo(params) {
    return request({
      url: `biz/tradecore/order/getWechatAppId${
        params && params.md5Sign ? '/scan' : ''
      }?payWay=104&payPartnerCode=HUIFU_WECHAT`,
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 获取连连支付appid信息
   * @static
   * @return {*}
   */
  static getLianLianPayInfo(params) {
    return request({
      url: `biz/tradecore/order/getWechatAppId${
        params && params.md5Sign ? '/scan' : ''
      }?payWay=105&payPartnerCode=LIANLIAN_WECHAT`,
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 获取富友2支付appid信息
   * @static
   * @return {*}
   */
  static getFuiouTwoPayInfo(params) {
    return request({
      url: `biz/tradecore/order/getWechatAppId${
        params && params.md5Sign ? '/scan' : ''
      }?payWay=100&payPartnerCode=FUIOU_WECHAT_TWO`,
      host: config.HOST_MALL,
      params
    });
  }

  static getALLinPayInfo(params) {
    return request({
      url: `biz/tradecore/order/getWechatAppId${
        params && params.md5Sign ? '/scan' : ''
      }?payWay=102&payPartnerCode=ALLINPAY`,
      host: config.HOST_MALL,
      params
    });
  }
  // 获取appId
  static getWechatPayInfoAppId(url, params) {
    return request({
      url,
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 查询未支付的开店订单
   */
  static getOpenStoreOrder() {
    return request({
      url: `tradecore/order/myorder/list-by-page`,
      host: config.HOST_MALL,
      method: 'post_json',
      ignoreErr: true,
      data: {
        dgStatus: 0,
        pageNum: 1,
        pageSize: 1,
        orderType: 5,
        orderStatus: 'INIT'
      }
    });
  }

  /**
   * 校验验证码
   */
  static checkVerifyCode(params) {
    return request({
      url: 'user/verifyCode/checkVerifyCodeByResetPwd',
      host: config.HOST_MALL,
      // method: 'post_json',
      params
    });
  }

  /**
   * 获取图形二维码
   */
  static getCaptcha(phone) {
    return request({
      url: `user/verifyCode/captcha?phone=${phone}`,
      host: config.HOST_MALL,
      returnAll: true
    });
  }

  /**
   * getUserCount
   */
  static getUserCount(params) {
    return request({
      url: 'user/login/getUserCount',
      host: config.HOST_MALL,
      // method: 'post_json',
      params
    });
  }

  // 解密敏感信息
  static getDecyptMsg(params) {
    params.md5Sign = encodeURIComponent(
      Encrypts(
        `${new Date().getTime()}#${hex_md5((params.id || params.cardCode) + decryptParams).toUpperCase()}`
      )
    );
    return request({
      url: `decrypt/manager`,
      host: config.HOST_MALL,
      params
    });
  }
  // 可儿玫瑰更新健康顾问
  static setKerUpdateHealth(params) {
    return request({
      url: `user/info/updateHealth?healthCode=${params}`,
      host: config.HOST_MALL,
      method: 'post_json',
      ignoreErr: true
    });
  }

  // linkflow识别联系人
  static linkflowIdentifiers(params) {
    return request({
      url: 'linkflow/identifiers',
      host: config.HOST_MALL,
      method: 'post_json',
      ignoreErr: true,
      data: params
    });
  }
  /**
   * IM 签名
   */
  static getUserSig(data) {
    return request({
      host: config.HOST_MALL,
      url: `im/getUserSig?identifier=${data}`,
      data: data
    });
  }

  /**
   * 获取多卡号
   */
  static getCardCodeList(data) {
    return request({
      host: config.HOST_MALL,
      url: `user/login/getCardsListByPhoneVerifyCode`,
      method: 'post_json',
      data: data
    });
  }

  // 根据手机号获取对应手机号登录验证码发送前是否显示图像验证码
  static checkUserPhoneCodeShowStatus(params) {
    return request({
      host: config.HOST_MALL,
      url: `user/verifyCode/checkUserPhoneCodeShowStatus`,
      params
    });
  }

  static bindGoogle(params) {
    return request({
      host: config.HOST_MALL,
      url: `user/binding/userCenter/bindGoogle`,
      method: 'post',
      params
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Login/LoginServ.js